import React from "react"
import SEO from "../components/common/SEO"

export default function PrivacyPolicy() {
  return (
    <>
      <SEO
        title="Politique de Confidentialité | Centre Spa Land Saphir Palace"
        description="Politique de confidentialité du Centre Spa Land Saphir Palace concernant la collecte et l'utilisation des données personnelles."
        url="https://www.yourdomain.com/politique-confidentialite"
      />

      <main className="bg-[#f9f6f1] py-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
            <h1 className="text-4xl font-bold text-[#111111] mb-8">
              Politique de Confidentialité
            </h1>

            <p className="text-gray-600 mb-8">
              Dernière mise à jour : Juin 2026
            </p>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  1. Introduction
                </h2>

                <p>
                  Le Centre Spa Land Saphir Palace accorde une grande
                  importance à la protection de vos données personnelles.
                  Cette politique explique comment nous collectons,
                  utilisons et protégeons les informations que vous
                  nous transmettez via notre site internet.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  2. Données collectées
                </h2>

                <p>
                  Lorsque vous utilisez notre formulaire de contact ou
                  effectuez une demande de réservation, nous pouvons
                  collecter les informations suivantes :
                </p>

                <ul className="list-disc pl-6 mt-3 space-y-2">
                  <li>Nom et prénom</li>
                  <li>Numéro de téléphone</li>
                  <li>Adresse e-mail (facultative)</li>
                  <li>Message ou demande de réservation</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  3. Utilisation des données
                </h2>

                <p>
                  Les informations recueillies sont utilisées uniquement
                  pour :
                </p>

                <ul className="list-disc pl-6 mt-3 space-y-2">
                  <li>Répondre à vos demandes.</li>
                  <li>Organiser ou confirmer une réservation.</li>
                  <li>Améliorer la qualité de nos services.</li>
                  <li>Assurer le suivi de la relation client.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  4. Partage des données
                </h2>

                <p>
                  Vos données personnelles ne sont ni vendues ni louées
                  à des tiers. Elles sont utilisées exclusivement dans
                  le cadre des activités du Centre Spa Land Saphir Palace.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  5. Conservation des données
                </h2>

                <p>
                  Les informations sont conservées uniquement pendant la
                  durée nécessaire au traitement de votre demande et à la
                  gestion de la relation client.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  6. Sécurité
                </h2>

                <p>
                  Nous mettons en œuvre des mesures raisonnables afin de
                  protéger les informations personnelles contre tout accès
                  non autorisé, perte ou divulgation.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  7. Vos droits
                </h2>

                <p>
                  Vous pouvez demander l'accès, la rectification ou la
                  suppression de vos données personnelles en nous
                  contactant directement.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  8. Contact
                </h2>

                <p>
                  Pour toute question concernant cette politique de
                  confidentialité, vous pouvez nous contacter via notre
                  formulaire de contact ou par téléphone.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}